import { DetailsList, DetailsItem } from './CardDetailsLayout.styled'

type CardDetailsLayoutProps = {
  children: Array<React.ReactNode> | React.ReactNode
}

const CardDetailsLayout: React.FC<CardDetailsLayoutProps> = ({ children }) => {
  function renderItems() {
    if (!children) return null

    const normalizedChildren = Array.isArray(children) ? children : [children]

    return normalizedChildren.map((item: any, index: number) => {
      if (!item) return null
      return <DetailsItem key={index}>{item}</DetailsItem>
    })
  }

  return <DetailsList>{renderItems()}</DetailsList>
}

export default CardDetailsLayout
